import i18next from "../../../i18n";

i18next.addResourceBundle("en", "RequirementTable", {
    success_message: "Requirement updated successfully",
});

i18next.addResourceBundle("fr", "RequirementTable", {
    success_message: "Requirement updated successfully",
});
